/* eslint-disable import/prefer-default-export */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { getParamsFromLink } from 'helpers/util'

import s from './RequestTour.module.css'
import { ArrowIcon } from './ArrowIcon'

export function RequestTour(props) {
  const { propertyId, salesAgent, signedIn } = props

  const [listingUrl, setListingUrl] = useState('')

  useEffect(() => {
    if (propertyId !== undefined) {
      const params = getParamsFromLink()
      setListingUrl(
        `/listings/${propertyId}/tour${params['sales-agent'] ? `?sales-agent=${params['sales-agent']}` : ''}`
      )
    }
  }, [salesAgent, propertyId])

  const handleClick = () => {
    window.location.href = listingUrl
  }

  const handleKeyDown = () => (evt) => {
    if (evt.key === 'Enter') {
      handleClick()
    }
  }

  return (
    <div className={s.root} onClick={handleClick} onKeyDown={handleKeyDown} role="button" tabIndex="0">
      Request a tour
      <ArrowIcon className={s.icon} />
    </div>
  )
}

RequestTour.propTypes = {
  propertyId: PropTypes.number.isRequired,
  salesAgent: PropTypes.shape({
    id: PropTypes.number,
  }),
  signedIn: PropTypes.bool,
}

RequestTour.defaultProps = {
  signedIn: false,
}
